import { createGlobalStyle } from 'styled-components'
import bg from './times-circle-solid.svg'

export const AlertStyles = createGlobalStyle`
  .s-alert-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .s-alert-box {
    padding: 14px 75px;
    margin-top: 45px !important;
    right: auto !important;
    max-width: 600px;
  }
  
  .s-alert-box-inner {
    font-family: Montserrat;
    text-align: center;
  }
  
  .s-alert-top {
    width: auto;
    max-width: 600px;
    top: 0;
    left: 0;
    right: 0;
    bottom: auto;
    margin: 50px auto 100px;
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
  
  .s-alert-error {
    border-radius: 8px;
    background: #CE4F4F;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.27);
  }
  .s-alert-success {
    border-radius: 8px;
    background: #008000;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.27);
  }
  .s-alert-close {
    top: 50%;
    right: 1rem;
    margin-top: -10px;
    background-color: white;
    mask: url(${bg}) no-repeat 50% 50%;
  }
`

export default AlertStyles
